/**
 * Domain-specific configuration for frontend
 * This mirrors the backend metadata configuration
 */

interface DomainConfig {
  h1Title: string;
  h1Subtitle: string;
  brandName: string;
  contentType: string; // "novella" or "story"
  contentTypePlural: string; // "novellas" or "stories"
  contentTypeCapitalized: string; // "Novella" or "Story"
  writerType: string; // "novella writer" or "story writer"
  generatorType: string; // "novella generator" or "story generator"
}

const DOMAIN_CONFIGS: Record<string, DomainConfig> = {
  'novellas.ai': {
    h1Title: 'AI Novella Generator',
    h1Subtitle: 'Create Complete Novellas in Minutes',
    brandName: 'NovellaStream',
    contentType: 'novella',
    contentTypePlural: 'novellas',
    contentTypeCapitalized: 'Novella',
    writerType: 'novella writer',
    generatorType: 'novella generator'
  },
  'aistorygenerator.app': {
    h1Title: 'AI Story Generator',
    h1Subtitle: 'Create Complete Stories in Minutes',
    brandName: 'AI Story Generator',
    contentType: 'story',
    contentTypePlural: 'stories',
    contentTypeCapitalized: 'Story',
    writerType: 'story writer',
    generatorType: 'story generator'
  }
};

/**
 * Get domain-specific configuration based on current hostname
 */
export function getDomainConfig(): DomainConfig {
  // Check if we're in browser environment
  if (typeof window === 'undefined') {
    // Return default config for SSR
    return DOMAIN_CONFIGS['novellas.ai'];
  }

  // Extract base domain (remove www. if present)
  const hostname = window.location.hostname.replace(/^www\./, '');

  // Return config for domain, fallback to novellas.ai
  return DOMAIN_CONFIGS[hostname] || DOMAIN_CONFIGS['novellas.ai'];
}
